import "./home-hero-animation"
import "./methodik-list"
import "./header"
import "./handle-orientation"